// extracted by mini-css-extract-plugin
export default {"customized-column-width":"UpcomingRoyalties_customized-column-width__sWa-+"};